import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from '../../utils/baseQueryFn';


export const activityLogsApi = createApi({
    reducerPath: "activityLogsApi",
    baseQuery,
    endpoints: (builder) => ({
        getActivityLogs: builder.query({
            query: ({ page, limit, staff, startDate, endDate }) => {

                const queryParams = new URLSearchParams({
                    page,
                    limit,
                });

                if (staff.length > 0) {
                    queryParams.append('user_ids', JSON.stringify(staff));
                }

                if (startDate) {
                    queryParams.append('start_date', startDate);
                }

                if (endDate) {
                    queryParams.append('end_date', endDate);
                }

                const apiUrl = `main/v1/activity-log?${queryParams.toString()}`;

                return {
                    url: apiUrl,
                    method: "GET",
                };
            },
            transformResponse: (response) => response,
        }),
        getAllActivityLogs: builder.mutation({
            query: ({ page, limit, staff, startDate, endDate }) => {

                const queryParams = new URLSearchParams({
                    page,
                    limit,
                });

        if (staff.length > 0) {
          queryParams.append('user_ids', JSON.stringify(staff));
        }

        if (startDate) {
          queryParams.append('start_date', startDate);
        }

        if (endDate) {
          queryParams.append('end_date', endDate);
        }

        const apiUrl = `main/v1/activity-log?${queryParams.toString()}`;

        return {
          url: apiUrl,
          method: 'GET',
        };
      },
      providesTags: ['activityLogs'],
      transformResponse: (response) => response,
    }),
    deleteActivityLog: builder.mutation({
      query: (body) => ({
        url: `main/v1/activity-log/delete`,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body,
      }),
      invalidatesTags: ['activityLogs'],
    }),
  }),
});

export const { useGetActivityLogsQuery, useGetAllActivityLogsMutation, useDeleteActivityLogMutation } = activityLogsApi;
